<template>
  <div class="container why-concerned">
    <div class="row pt-2">
      <div class="col-12 offset-md-2 col-md-8">
        <vm-progress :percentage="66" :show-text="false" :stroke-width="12" :strokeColor="'#2bb1c4'"></vm-progress>
      </div>
    </div>
    <back-and-skip :hideSkip='true'>
    </back-and-skip>
    <div class="row pt-4 pt-lg-4">
      <div class="col-12 text-center">
        <img class="img-question" src="../assets/wont_take_vaccine.svg" alt="why-concerned">
      </div>
    </div>
    <div class="row pt-4 row-title">
      <div class="col-12 offset-lg-2 col-lg-8 text-center text-wrap">
        <label class="title">
          {{ $t('whyConcerned.title') }}
        </label>
      </div>
    </div>
    <div class="row row-options">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="reason" value="dont-think-work" id="dont-think-work" type="radio"/>
        <label class="option-label" for="dont-think-work">{{ $t('whyConcerned.dontThinkWork') }}</label>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <input v-model="reason" value="price-treatment" id="price-treatment" type="radio"/>
        <label class="option-label" for="price-treatment">{{ $t('whyConcerned.priceTreatment') }}</label>
      </div>
    </div>
    <div class="row pt-4">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="reason" value="dont-trust-drug-manufactures" id="dont-trust-drug-manufactures" type="radio"/>
        <label class="option-label" for="dont-trust-drug-manufactures">{{ $t('whyConcerned.dontTrust') }}</label>
      </div>
      <div class="col-6 col-lg-4 pl-0">
        <input v-model="reason" value="scared-it-will-hurt" id="scared-it-will-hurt" type="radio"/>
        <label class="option-label" for="scared-it-will-hurt">{{ $t('whyConcerned.scared') }}</label>
      </div>
    </div>
    <div class="row pt-3">
      <div class="col-6 offset-lg-3 col-lg-4 pr-0">
        <input v-model="reason" value="other" id="other" type="radio"/>
        <label class="option-label" for="other">{{ $t('whyConcerned.other') }}</label>
      </div>
    </div>
    <div class="row pt-1">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <input v-model="other"
          placeholder="Other"
          type="text"
          class="form-control other"
          :style="{visibility: showOther? 'visible' : 'hidden'}">
      </div>
    </div>
    <div class="row pt-4 pb-2">
      <div class="col-12 offset-lg-2 col-lg-8 text-center">
        <button class="btn btn-lg text-light next" @click="next">
          {{ $t('general.next') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import BackAndSkip from '../components/BackAndSkip.vue'

export default {
  data () {
    return {
      reason: '',
      other: '',
      showOther: false
    }
  },
  components: {
    BackAndSkip
  },
  methods: {
    next () {
      if (this.$v.$invalid) {
        this.$swal({
          icon: 'error',
          title: 'Error',
          text: this.$t('general.selectOptionError')
        })
      } else {
        if (this.reason === 'other' && this.other === '') {
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: this.$t('general.pleaseSpecifyError')
          })

          return
        }

        const answer = {
          key: 'why_concerned',
          value: this.reason === 'other' ? this.other : this.reason
        }

        this.$store.commit('SET_DATA_SURVEY', answer)

        this.$router.push({
          name: 'preventativehealth'
        })
      }
    }
  },
  watch: {
    reason (val) {
      if (val === 'other') {
        this.showOther = true
      } else {
        this.showOther = false
      }
    }
  },
  validations: {
    reason: {
      required
    }
  },
  mounted () {
    this.$store.commit('SET_LAST_PAGE', 'whyconcerned')
  }
}
</script>

<style>
.why-concerned .img-question {
  width: 100%;
  height: 28vh;
}

.why-concerned .title {
  font-weight: 700;
  font-size: 1.3rem;
}

.why-concerned .row-options {
  padding-top: 3rem;
}

.why-concerned [type="radio"]:checked, [type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}

.why-concerned [type="radio"]:checked + label, [type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
}

.why-concerned [type="radio"]:checked + label:before, [type="radio"]:not(:checked) + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #fff;
}

.why-concerned [type="radio"]:checked + label:after, [type="radio"]:not(:checked) + label:after {
  content: '';
  width: 10px;
  height: 10px;
  background: #2bb1c4;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.why-concerned [type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}

.why-concerned [type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}

.why-concerned .other {
  width: 100%;
  height: 7vh;
  font-size: 12px;
  color: black;
}

.why-concerned .next {
  width: 85%;
  min-height: 83px;
  background-color: #2bb1c4;
  font-weight: 300;
  border-radius: 15px;
}

@media screen and (device-aspect-ratio: 40/71) {
  .why-concerned .img-question {
    width: 100%;
    height: 16vh;
  }

  .why-concerned .title {
    font-size: 1rem;
  }

  .why-concerned .row-options {
    padding-top: 1rem;
  }

  .why-concerned .option-label {
    font-size: .8rem;
  }

  .why-concerned .other {
    width: 100%;
    height: 6vh;
  }

  .why-concerned .next {
    min-height: 70px;
  }
}
</style>
